<template>
  <div class="tagcloud">
    <router-link v-for="(tag, index) in tags" :key="`${tag.slug}-${index}`" :to="`/tag/${tag.slug}`">
      {{ $t('Blog.tags.' + tag.title) }}
    </router-link>
  </div>
</template>

<script>
import BlogPostMixin from '../../mixins/BlogPostMixin'

export default {
  name: 'BlogTags',
  mixins: [BlogPostMixin]
}
</script>
